import { render, staticRenderFns } from "./VCard.vue?vue&type=template&id=b1c2e5c8&scoped=true&lang=pug&"
import script from "./VCard.vue?vue&type=script&lang=js&"
export * from "./VCard.vue?vue&type=script&lang=js&"
import style0 from "./VCard.vue?vue&type=style&index=0&id=b1c2e5c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1c2e5c8",
  null
  
)

export default component.exports